// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file chat/v3/chat_recording.proto (package chat.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message as Message$1 } from "./chat_messages_pb";
import { file_chat_v3_chat_messages } from "./chat_messages_pb";
import type { AuditMetadata } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { LanguageRegion } from "../../i18n/v3/language_regions_pb";
import { file_i18n_v3_language_regions } from "../../i18n/v3/language_regions_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v3/chat_recording.proto.
 */
export const file_chat_v3_chat_recording: GenFile = /*@__PURE__*/
  fileDesc("ChxjaGF0L3YzL2NoYXRfcmVjb3JkaW5nLnByb3RvEgdjaGF0LnYzImMKD1JlY29yZGVkTWVzc2FnZRItCgl0aW1lc3RhbXAYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiEKB21lc3NhZ2UYAiABKAsyEC5jaGF0LnYzLk1lc3NhZ2Ui1gIKCVJlY29yZGluZxIkCgptZXNzYWdlX2lkGAEgASgJQhCatRgMc3RpZC5NZXNzYWdlEioKCG1lc3NhZ2VzGAIgAygLMhguY2hhdC52My5SZWNvcmRlZE1lc3NhZ2USMAoRcGFyZW50X21lc3NhZ2VfaWQYAyABKAlCEJq1GAxzdGlkLk1lc3NhZ2VIAIgBARIqCg5zb3VyY2VfY2hhdF9pZBgEIAEoCUINmrUYCXN0aWQuQ2hhdEgBiAEBEjAKEXNvdXJjZV9tZXNzYWdlX2lkGAUgASgJQhCatRgMc3RpZC5NZXNzYWdlSAKIAQESKAoGc3RhdHVzGAYgASgOMhguY2hhdC52My5SZWNvcmRpbmdTdGF0dXNCFAoSX3BhcmVudF9tZXNzYWdlX2lkQhEKD19zb3VyY2VfY2hhdF9pZEIUChJfc291cmNlX21lc3NhZ2VfaWQigwMKBENoYXQSIQoHY2hhdF9pZBgBIAEoCUIQmrUYDHN0aWQuTWVzc2FnZRINCgV0aXRsZRgCIAEoCRIwCg9sYW5ndWFnZV9yZWdpb24YAyABKA4yFy5pMThuLnYzLkxhbmd1YWdlUmVnaW9uEigKCXRlbmFudF9pZBgEIAEoCUIVmrUYEXN0aWQuT3JnYW5pemF0aW9uEigKDHdvcmtzcGFjZV9pZBgFIAEoCUISmrUYDnN0aWQuV29ya3NwYWNlEiQKCnByb2plY3RfaWQYBiABKAlCEJq1GAxzdGlkLlByb2plY3QSNgoScHVibGljYXRpb25fc3RhdHVzGAcgASgOMhouY2hhdC52My5QdWJsaWNhdGlvblN0YXR1cxIwCg5hdWRpdF9tZXRhZGF0YRgIIAEoCzIYLmNvbW1vbi52My5BdWRpdE1ldGFkYXRhEjMKEXJlY29yZGVkX21lc3NhZ2VzGAkgAygLMhguY2hhdC52My5SZWNvcmRlZE1lc3NhZ2UqbgoPUmVjb3JkaW5nU3RhdHVzEiAKHFJFQ09SRElOR19TVEFUVVNfVU5TUEVDSUZJRUQQABIXChNSRUNPUkRJTkdfU1RBVFVTX09LEAESIAocUkVDT1JESU5HX1NUQVRVU19MT0FEX0ZBSUxFRBACKnYKEVB1YmxpY2F0aW9uU3RhdHVzEiIKHlBVQkxJQ0FUSU9OX1NUQVRVU19VTlNQRUNJRklFRBAAEh4KGlBVQkxJQ0FUSU9OX1NUQVRVU19QUklWQVRFEAESHQoZUFVCTElDQVRJT05fU1RBVFVTX1BVQkxJQxACQldaVWdpdGh1Yi5jb20vU3Rvcnl0ZWxsLWFpL3N0b3J5dGVsbC1haS1wbGF0Zm9ybS9wa2cvZ28vZG9tYWlucy9jcC9nZW4vcGIvY2hhdC92MztjaGF0VjNiBnByb3RvMw", [file_google_protobuf_timestamp, file_chat_v3_chat_messages, file_common_v3_common, file_i18n_v3_language_regions]);

/**
 * RecordedMessage represents a message that was recorded with its timestamp
 *
 * @generated from message chat.v3.RecordedMessage
 */
export type RecordedMessage = Message<"chat.v3.RecordedMessage"> & {
  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp: Timestamp;

  /**
   * @generated from field: chat.v3.Message message = 2;
   */
  message: Message$1;
};

/**
 * Describes the message chat.v3.RecordedMessage.
 * Use `create(RecordedMessageSchema)` to create a new message.
 */
export const RecordedMessageSchema: GenMessage<RecordedMessage> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_recording, 0);

/**
 * Recording represents a complete recording of a chat session
 *
 * @generated from message chat.v3.Recording
 */
export type Recording = Message<"chat.v3.Recording"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: repeated chat.v3.RecordedMessage messages = 2;
   */
  messages: RecordedMessage[];

  /**
   * @generated from field: optional string parent_message_id = 3;
   */
  parentMessageId: string;

  /**
   * @generated from field: optional string source_chat_id = 4;
   */
  sourceChatId: string;

  /**
   * @generated from field: optional string source_message_id = 5;
   */
  sourceMessageId: string;

  /**
   * @generated from field: chat.v3.RecordingStatus status = 6;
   */
  status: RecordingStatus;
};

/**
 * Describes the message chat.v3.Recording.
 * Use `create(RecordingSchema)` to create a new message.
 */
export const RecordingSchema: GenMessage<Recording> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_recording, 1);

/**
 * @generated from message chat.v3.Chat
 */
export type Chat = Message<"chat.v3.Chat"> & {
  /**
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: i18n.v3.LanguageRegion language_region = 3;
   */
  languageRegion: LanguageRegion;

  /**
   * @generated from field: string tenant_id = 4;
   */
  tenantId: string;

  /**
   * @generated from field: string workspace_id = 5;
   */
  workspaceId: string;

  /**
   * @generated from field: string project_id = 6;
   */
  projectId: string;

  /**
   * @generated from field: chat.v3.PublicationStatus publication_status = 7;
   */
  publicationStatus: PublicationStatus;

  /**
   * Audit metadata
   *
   * @generated from field: common.v3.AuditMetadata audit_metadata = 8;
   */
  auditMetadata: AuditMetadata;

  /**
   * @generated from field: repeated chat.v3.RecordedMessage recorded_messages = 9;
   */
  recordedMessages: RecordedMessage[];
};

/**
 * Describes the message chat.v3.Chat.
 * Use `create(ChatSchema)` to create a new message.
 */
export const ChatSchema: GenMessage<Chat> = /*@__PURE__*/
  messageDesc(file_chat_v3_chat_recording, 2);

/**
 * RecordingStatus indicates whether the recording was successfully loaded
 *
 * @generated from enum chat.v3.RecordingStatus
 */
export enum RecordingStatus {
  /**
   * @generated from enum value: RECORDING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RECORDING_STATUS_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: RECORDING_STATUS_LOAD_FAILED = 2;
   */
  LOAD_FAILED = 2,
}

/**
 * Describes the enum chat.v3.RecordingStatus.
 */
export const RecordingStatusSchema: GenEnum<RecordingStatus> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_recording, 0);

/**
 * @generated from enum chat.v3.PublicationStatus
 */
export enum PublicationStatus {
  /**
   * Default value, should not be used
   *
   * @generated from enum value: PUBLICATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The chat is a draft and not yet published
   *
   * @generated from enum value: PUBLICATION_STATUS_PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * The chat is published and available to the world
   *
   * @generated from enum value: PUBLICATION_STATUS_PUBLIC = 2;
   */
  PUBLIC = 2,
}

/**
 * Describes the enum chat.v3.PublicationStatus.
 */
export const PublicationStatusSchema: GenEnum<PublicationStatus> = /*@__PURE__*/
  enumDesc(file_chat_v3_chat_recording, 1);

